export const sumakomiCircle = () => {

    class CustomCircle {

        constructor(options = {}) {

            this.map = options.map || null;
            this.markers = options.markers || null;

            // Circle
            this.lat = options.lat || 34.684257;
            this.lng = options.lng || 135.511053;
            this.fillOpacity = options.fillOpacity || 0.2;
            this.fillColor = options.fillColor || "#ff5a45";
            this.strokeOpacity = options.strokeOpacity || 0.7;
            this.strokeColor = options.strokeColor || "#ff5a45";
            this.strokeWeight = options.strokeWeight || 2;
            this.zIndex = options.zIndex || 1;
            this.radius = options.radius || 1000;
            this.editable = options.editable || true;
            this.draggable = options.draggable || true;

            // Instance
            this.latLng = new google.maps.LatLng(this.lat, this.lng);
            this.circle = new google.maps.Circle({
                map: this.map,
                center: this.latLng,
                radius: this.radius,
                editable: this.editable,
                draggable: this.draggable,
                fillOpacity: this.fillOpacity,
                fillColor: this.fillColor,
                strokeOpacity: this.strokeOpacity,
                strokeColor: this.strokeColor,
                strokeWeight: this.strokeWeight,
                zindex: this.zIndex,
            });

        }

        get getCircle() {
            return this.circle;
        }

        get getRadiusNum() {
            return this.circle.getRadius();
        }

        set setRadius(num) {
            this.circle.setRadius(Number(num));
        }
    }

    window.CustomCircle = CustomCircle;

}